export const serializeParams = params => {
  return Object.keys(params || {})
    .filter(param => !(params[param] === undefined || params[param] === null))
    .map(
      param =>
        `${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`
    )
    .join('&');
};
